/* eslint-disable import/first */
if (module.hot) {
  module.hot.accept();
}

import './css/main.css';
import './js/application';
/* eslint-enable import/first */



// WEBPACK FOOTER //
// ./src/entry.js